/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-require-imports */
'use client';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from 'react';
import SelectTime from './select-time';
import {
  generateGUID,
  generateRangeColor,
  mapModifiers,
  notify,
  parseToExport,
  slugify,
  slugifyFileName,
} from '@/utils/funtion';
import base64Logo from '@/assets/base64/logo.json';
import SelectProvince from './select-province';
import useDirectDetail from '@/helpers/useDirectDetail';
import { AiOutlineFullscreen } from 'react-icons/ai';
import Dropdown from '@/components/atoms/dropdown';
import { FiDownload } from 'react-icons/fi';
import { itemsMenu } from '@/statics/static';
import Spin from '@/components/atoms/spin';
import { Empty } from 'antd';
import PermissionModal from '@/components/organisms/permission-modal';
import useGetNewPlans from '@/helpers/useGetNewPlans';
import { checkDownloadStatus } from '@/services/apis/modules/plans';
import { useData } from '@/stores/context';
import { FaReact, FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { BsDatabaseCheck } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import PopupConfirm from '@/components/molecules/popupConfirm';
import { registerAPI } from '@/services/apis/modules/home';
import { errorsMessage } from '@/libs/errors';
import { dataMapStatic } from '@/statics/data';
import { staticCustomKey } from '../mapsPackage';
import { useUnauthorized } from '@/stores/context/unauthorized';

let HighchartsMap: any;

if (typeof window !== 'undefined') {
  HighchartsMap = require('highcharts/modules/map')(Highcharts);
}

interface ProvinceData {
  name: string;
  value: string | number | undefined;
  keyMapping: string;
  id: string;
}

interface colorAxisDataClasses {
  from?: number;
  to?: number;
  color: '#0000ee';
}

interface Props {
  data: ProvinceData[];
  mapDataVN: any;
  id?: string;
  title: string;
  isCustom?: boolean;
  loading?: boolean;
  colorAxisRange?: colorAxisDataClasses[];
  titleColorAxis?: string;
  original: string | undefined;
  originalUrl: string | undefined;
  unit: string | undefined;
  timeData: string[];
  chartType?: string;
  dataType?: string;
  isPageDetail?: boolean;
  onSelectTime: (value: string) => void;
}

const VietnamMap: React.FC<Props> = ({
  id,
  data,
  mapDataVN,
  title,
  titleColorAxis,
  originalUrl,
  original,
  unit,
  timeData,
  onSelectTime,
  isCustom,
  loading,
  chartType,
  dataType,
  isPageDetail,
}) => {
  const { innerWidth, handleSetStatusAssitant, handleSetDataQuestion } =
    useData();
  const { handleOpenUnauthorized } = useUnauthorized();

  const userData = useSelector((state: any) => state.userData);

  const chartRef = useRef(null);
  const rangeColor = useMemo(() => generateRangeColor(data), [data]);
  const { handleDirectDetail } = useDirectDetail();
  const [modal, setModal] = useState({
    title: '',
    open: false,
  });

  const [api, setAPI] = useState({
    open: false,
    loading: false,
  });
  const [viewIndicator, setViewIndicator] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  const { fetchNewPlan } = useGetNewPlans();

  const handleModalClose = useCallback(() => {
    setModal((prev) => ({ ...prev, open: false }));
  }, []);

  const handleAPIClose = useCallback(() => {
    setAPI((prev) => ({ ...prev, open: false, loading: false }));
  }, []);

  const handleViewIndicator = useCallback(() => {
    if (!!userData?.user) {
      setViewIndicator((prev) => !prev);
    } else {
      setModal({
        title: 'Hiển thị chỉ số trên biểu đồ',
        open: true,
      });
    }
  }, [userData]);

  const handleFullScreen = useCallback(() => {
    if (!userData?.user) {
      setModal({
        title: 'Hiển thị chỉ số toàn màng hình',
        open: true,
      });
    } else {
      handleDownloadOption('fullScreen');
    }
  }, [userData]);

  const handleRegisterAPI = useCallback(async () => {
    setAPI((prev) => ({ ...prev, loading: true }));

    try {
      const response = await checkDownloadStatus({
        type: 'api',
        groupData: 'local',
      });

      if (response?.status) {
        const { data } = response;
        if (data?.downLoadStatus) {
          const result = await registerAPI({
            id: id as string,
            type: 'local_indicator',
          });
          if (result.status) {
            notify(
              'success',
              'Đăng ký thành công, Vui lòng kiểm tra mail để nhận thông tin tích hợp API nhé ❤!',
              'top-center',
              8000,
            );
          } else {
            notify(
              'error',
              'Đăng ký không thành công, Vui lòng kiểm tra lại gói dịch vụ',
              'top-center',
              7000,
            );
          }
        } else {
          notify('info', 'Bạn đã hết lượt đăng kí API');
        }
      } else {
        if (response.key === 'unauthorized') {
          setAPI((prev) => ({ ...prev, loading: false, open: false }));
          handleOpenUnauthorized(window.location.pathname);
        } else {
          notify(
            'error',
            errorsMessage[response.key] ?? 'Xảy ra lỗi',
            'top-right',
          );
        }
      }
    } finally {
      setAPI((prev) => ({ ...prev, loading: false, open: false }));
    }
  }, [id]);

  const chartOptions = useMemo(
    () => ({
      credits: { enabled: false },
      mapNavigation: { enabled: false },
      title: {
        text: titleColorAxis,
        align: 'left',
        style: {
          textTransform: 'uppercase',
        },
      },
      subtitle: {
        text: `Đơn vị: ${unit}`,
        style: {
          color: '#0489dc',
          textAlign: 'left',
          marginTop: 8,
          fontSize: 15,
        },
        align: 'left',
      },
      chart: {
        animation: true,
        width: null,
        marginBottom: innerWidth < 450 ? 120 : 90,
        height: innerWidth < 450 ? 780 : 720,
        map: 'countries/vn/vn-all',
        marginLeft: 50,
        events: {
          render() {
            const chart: any = this;
            chart['customImage']?.destroy();
            const widthHeight = innerWidth < 450 ? 180 : 70;
            const plotWidth = chart.plotWidth - 20;
            const chartHeight = chart.chartHeight - 80;
            const logoProps = [
              plotWidth,
              chartHeight,
              widthHeight,
              widthHeight,
            ];
            chart.customImage = chart.renderer
              .image(base64Logo.data, ...logoProps)
              .attr({ opacity: 0.2 })
              .add();
          },
        },
      },
      plotOptions: {
        series: {
          borderWidth: chartType === 'maps34' ? 0.3 : 0.5,
          borderColor: '#04566e',
          states: {
            hover: {
              borderColor: '#04566e',
              borderWidth: 1,
            },
          },
        },
      },
      caption: {
        text: `© Vietstats ${new Date().getFullYear()} | Nguồn dữ liệu: ${original || ''} | Tổng hợp: ${originalUrl || 'Vietstats'}`,
        style: {
          fontSize: 15,
          color: '#0489dc',
          transform: 'translateX(-1px)',
        },
        x: 0,
        y: 18,
      },
      exporting: {
        enabled: false,
        width: 1920,
        printMaxWidth: 1920,
        sourceWidth: 1080,
        sourceHeight: 720,
        scale: 1,
        fallbackToExportServer: false,
        pdfFont: {
          normal: 'fonts/Roboto-Regular.ttf',
        },
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
          const point = this.point as any;
          if (staticCustomKey.includes(point['hc-key']))
            return `${point?.name}`;
          return `${point?.name} - <strong>${point?.value?.toLocaleString('vi-VN')}</strong> ${unit ?? ''}`;
        },
      },
      series: [
        {
          name: titleColorAxis,
          type: 'map',
          mapData: mapDataVN,

          states: { hover: { color: '#04566e', borderWidth: 0 } },
          data: [
            ...data?.map((item) => ({
              'hc-key': item?.keyMapping?.toLowerCase()?.replaceAll('_', '-'),
              value: parseFloat(parseFloat(item?.value as string).toFixed(2)),
              name: item.name,
              id: item.id,
              keyMapping: item?.keyMapping?.toLowerCase()?.replaceAll('_', '-'),
              dataLabels: {
                inside: true,
                enabled: viewIndicator,
                format: '{point.name} {point.value:,.2f}',
                style: { fontFamily: 'Arial, sans-serif', shadow: true },
                color: '#000',
                align: 'left',
                allowOverlap: false,
              },
            })),
            ...dataMapStatic?.map((item) => ({
              ...item,
              dataLabels: {
                inside: true,
                enabled: true,
                format: '{point.name}',
                style: { fontFamily: 'Arial, sans-serif', shadow: false },
                color: '#000',
                align: 'center',
                allowOverlap: true,
              },
            })),
          ],
          point: {
            events: {
              click: function () {
                const { id, keyMapping } = this as any;
                if (staticCustomKey.includes(keyMapping)) return;
                handleDirectDetail(
                  keyMapping,
                  id,
                  'local_indicator',
                  false,
                  false,
                  true,
                );
              },
            },
          },
        },
      ],
      colorAxis: {
        dataClasses: rangeColor.map((item: any) => ({
          ...item,
          name:
            item.to === item.from
              ? Number(item.to).toLocaleString('vi-VN')
              : `${Number(item.from).toLocaleString('vi-VN')} - ${Number(item.to).toLocaleString('vi-VN')}`,
        })),
      },
      legend: {
        title: {
          text: titleColorAxis,
          style: {
            color:
              Highcharts.defaultOptions?.legend?.title?.style?.color || 'black',
          },
        },
        align: 'left',
        verticalAlign: 'bottom',
        floating: false,
        layout: 'horizontal',
        valueDecimals: 0,
        backgroundColor:
          Highcharts.defaultOptions?.legend?.backgroundColor ||
          'rgba(255, 255, 255, 0)',
        symbolRadius: 0,
        symbolHeight: 14,
        y: 20,
        x: -10,
      },
    }),
    [
      data,
      mapDataVN,
      titleColorAxis,
      unit,
      original,
      originalUrl,
      innerWidth,
      viewIndicator,
      rangeColor,
      chartType,
    ],
  );

  const handleDownloadOption = useCallback(
    async (option: string) => {
      if (!chartRef.current) return;

      const filename = { filename: `${slugifyFileName(title)}` };
      const chartOption: any = {
        title: {
          text: name,
          style: {
            fontSize: '26px',
            fontWeight: 'bold',
            marginBottom: 12,
          },
        },
        chart: { backgroundColor: '#FFFFFF' },
        xAxis: {
          labels: {
            style: {
              fontSize: '22px',
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '22px',
            },
          },
        },
        caption: {
          style: {
            fontSize: '20px',
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              style: {
                fontSize: '22px',
              },
            },
          },
        },
      };

      const chart = (chartRef.current as any).chart;

      switch (option) {
        case 'downloadPNG':
        case 'downloadJPEG':
        case 'downloadSVG':
          chart?.exportChartLocal(
            {
              type:
                option === 'downloadPNG'
                  ? 'image/png'
                  : option === 'downloadJPEG'
                    ? 'image/jpeg'
                    : 'image/svg+xml',
              ...filename,
              scale: 2,
            },
            chartOption,
          );
          break;
        case 'downloadPDF':
          chart?.exportChartLocal(
            {
              type: 'application/pdf',
              ...filename,
              allowHTML: true,
              scale: 2,
              chartOptions: chartOption,
            },
            chartOption,
          );
          break;
        case 'downloadXLS':
          chart?.downloadXLS();
          await parseToExport(
            data,
            original || '',
            title,
            unit || '',
            false,
            false,
            false,
            dataType as any,
            'maps',
          );
          setDownloadSuccess(true);
          break;
        case 'fullScreen':
          chart?.fullscreen?.open();
          break;
      }
    },
    [data, title, original, unit, dataType],
  );

  const handleDownload = useCallback(
    async (info: any) => {
      setDownloadSuccess(false);
      const downloadTypes = {
        excel: ['downloadCSV', 'downloadXLS'],
        image: ['downloadPNG', 'downloadJPEG'],
        pdf: ['downloadPDF', 'downloadSVG'],
      };

      const mappingKeyDownload: Record<string, string> = {
        excel: 'excel',
        image: 'image_pdf',
      };

      const type = Object.entries(downloadTypes).find(([_, types]) =>
        types.includes(info.key),
      )?.[0];

      if (!type) return;

      const res = await checkDownloadStatus({
        type: mappingKeyDownload[type] || 'pdf_svg',
        groupData: 'local',
      });

      if (res.status && res?.data?.downLoadStatus) {
        handleDownloadOption(info.key);
        setDownloadSuccess(true);
      } else {
        if (res.key === 'unauthorized') {
          handleOpenUnauthorized(window.location.pathname);
        } else {
          setModal({
            ...modal,
            title: `Download biểu đồ dạng ${type === 'excel' ? 'Excel/CSV' : type === 'image' ? 'PNG/JPEG' : 'PDF/SVG'}`,
            open: true,
          });
        }
      }
    },
    [handleDownloadOption, modal],
  );

  useEffect(() => {
    if (downloadSuccess) fetchNewPlan();
  }, [downloadSuccess, fetchNewPlan]);

  const renderChart = useMemo(() => {
    if (loading || !data) {
      return (
        <div className="t-chart_package_loading" style={{ height: 900 }}>
          {loading ? <Spin /> : <Empty description="Không có dữ liệu ...!" />}
        </div>
      );
    }

    return (
      <div className="t-chart_package_chart">
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={'mapChart'}
          options={chartOptions}
          allowChartUpdate={true}
          ref={chartRef}
        />
      </div>
    );
  }, [data, loading, chartOptions]);

  return (
    <div className={mapModifiers('t-local-map', isCustom && 'custom')}>
      <div className="t-local-map_header">
        <div className="t-local-map_header_province">
          <SelectProvince data={data} />
        </div>
        <ul className="t-local-map_header_action">
          {isPageDetail && (
            <div
              className={mapModifiers('t-local-map_header_action_ai')}
              style={{ display: 'flex', alignItems: 'center' }}
              onClick={async () => {
                const res = await checkDownloadStatus({
                  type: 'ai_data_analysis',
                  groupData: 'ai_data_analysis',
                });
                if (res?.data?.downLoadStatus || res.status) {
                  handleSetStatusAssitant('popup');
                  handleSetDataQuestion(generateGUID());
                } else {
                  if (res.key === 'unauthorized') {
                    handleOpenUnauthorized(window.location.pathname);
                  } else {
                    setModal({
                      title: 'Phân tích chỉ số với AI Chatbot',
                      open: true,
                    });
                  }
                }
              }}
            >
              <FaReact className={mapModifiers('download-icon', 'ai')} />
              {innerWidth > 950 && <p>Phân tích với AI</p>}
            </div>
          )}
          <div
            className={mapModifiers('t-local-map_header_action_api')}
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={() => {
              if (userData?.user?.permission?.isRegisterAPI) {
                setAPI((prev) => ({ ...prev, open: true }));
              } else {
                setModal({
                  title: 'Đăng kí API',
                  open: true,
                });
              }
            }}
          >
            <BsDatabaseCheck className={mapModifiers('download-icon', 'api')} />
            {innerWidth > 950 && <p>API</p>}
          </div>
          <div
            className={mapModifiers('t-local-map_header_action_eye')}
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={handleViewIndicator}
          >
            {!viewIndicator ? (
              <FaRegEye className={mapModifiers('download-icon', 'eye')} />
            ) : (
              <FaRegEyeSlash className={mapModifiers('download-icon', 'eye')} />
            )}
            {innerWidth > 950 && <p>Xem dữ liệu</p>}
          </div>
          <li className="t-local-map_header_action_fullscreen">
            <AiOutlineFullscreen
              className={mapModifiers('download-icon', 'fullScreen')}
              onClick={handleFullScreen}
            />
            {innerWidth > 950 && <p>Toàn màn hình</p>}
          </li>
          <li className="t-local-map_header_action_download">
            <Dropdown
              options={{
                items: itemsMenu,
                onClick: handleDownload,
              }}
            >
              <div className="dropdown-trigger">
                <FiDownload
                  className={mapModifiers('download-icon', 'dropdown')}
                />
                {innerWidth > 950 && <p>Tải dữ liệu</p>}
              </div>
            </Dropdown>
          </li>
        </ul>
      </div>
      {innerWidth > 960 && (
        <div className={mapModifiers('t-local-map_header-time')}>
          <SelectTime
            timeData={timeData}
            onSelectTime={onSelectTime}
            slug={slugify(titleColorAxis || '')}
          />
        </div>
      )}

      {innerWidth < 960 && (
        <div className={mapModifiers('t-local-map_header-time_mobile')}>
          <SelectTime
            timeData={timeData}
            onSelectTime={onSelectTime}
            slug={slugify(titleColorAxis || '')}
          />
        </div>
      )}
      {renderChart}
      <PermissionModal
        open={modal.open}
        onCancel={handleModalClose}
        title={modal.title}
      />
      <PopupConfirm
        title="Xác nhận đăng kí API"
        message={'Bạn chắc chắc muốn đăng kí API với chỉ số ' + titleColorAxis}
        open={api.open}
        cancelText="Hủy"
        confirmText="Đồng ý"
        loading={api.loading}
        onCancel={handleAPIClose}
        onConfirm={handleRegisterAPI}
      />
    </div>
  );
};

export default React.memo(VietnamMap);
